import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Box } from "@mui/material";
import JobpostingDetailsTabs from "../../JobPostings_New_UI/JobpostingDetails/JobpostingDetailsTabs/JobpostingDetailsTabs";
import { setSelectedJobPosting } from "../../../_redux/SelectedJobPostingSlice";
import { toggleSidebar } from "../../../_redux/Uislice";
import * as _ser from "../../../_redux/_services/JobPostingSlice";

const initalState = {
    data: null,
    message: "",
    isloader: true,
};
const PostingsDetailView = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            dispatch(setSelectedJobPosting({ storedJobPostingId: id }));
        }
    }, [id, dispatch]);

    useEffect(() => {
        dispatch(toggleSidebar(true));
        return () => {
            dispatch(toggleSidebar(false));
        };
    }, [dispatch]);

    const onReceivePropsHandler = (status, type) => {
        if (status === "close" || type === "close" || status === "deleted" || type === "deleted") {
            navigate("/ats/layout/jobpostings/list/landing", {
                state: { viewMode: (status === "deleted" || type === "deleted") ? "table" : undefined },
                replace: true
            });
            dispatch(_ser.jobpostingsbyidStartReducer(initalState))
        }

    };

    return (
        <Box sx={{ p: 3, bgcolor: "#fff", minHeight: "100vh", marginTop: "-20px" }}>
            <JobpostingDetailsTabs
                onReceiveProps={onReceivePropsHandler}
            />
        </Box>
    );
}

export default PostingsDetailView;
